import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ExtraPaymentRequest, PayrollRequest } from '../models/payroll.model';
import { ExistenceCountRequest, InventoryAuditRequest } from '../models/inventory.model';
import { PrioritiesInventoryRequest } from '../models/product.model';
import { CloseTransferDetailsRequest } from '../models/transfer-product.model';
import { producPriceRequest } from '../models/price-list.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  private URL = environment.api + "api/erp/inventory";

  constructor(
    private http: HttpClient
  ) { }

  getInventoryRandom(counted: number, user: number, warehouse: number) {
    return this.http.get(this.URL + "/inventoryRandom", {
      params: {
        counted: counted,
        user: user,
        warehouse: warehouse
      }
    });
  }

  setPhysicalStockOfList(list: ExistenceCountRequest[], user: number) {
    return this.http.post(this.URL + "/inventoryRandom/count", list, {
      params: {
        user: user
      }
    });
  }

  setPhysicalStockOfListIndividual(request: ExistenceCountRequest, user: number) {
    return this.http.post(this.URL + "/inventoryRandom/count-individual", request, {
      params: {
        user: user
      }
    });
  }

  getMissingWarehousesToCount() {
    return this.http.get(this.URL + "/inventoryRandom/missing");
  }

  getHistoryInventoryRandom() {
    return this.http.get(this.URL + "/inventoryRandom/history/allWarehouses");
  }

  getHistoryInventoryRandomByWarehouse(warehouse: number) {
    return this.http.get(this.URL + `/inventoryRandom/history/${warehouse}`);
  }

  getActualInventory() {
    return this.http.get(this.URL + `/inventoryRandom/actual`);
  }

  saveAudit(request: InventoryAuditRequest) {
    return this.http.post(this.URL + "/audit", request);
  }

  getPrioritiesInventoryByWarehouse(warehouse: number) {
    return this.http.get(this.URL + `/priority/list/${warehouse}`);
  }

  deletePriority(priority: number) {
    return this.http.delete(this.URL + `/priority/delete/${priority}`);
  }

  savePriorityInventory(request: PrioritiesInventoryRequest) {
    return this.http.post(this.URL + "/priority", request);
  }

  getTransfersByCompany(warehouseId: number, startDate: number, endDate: number) {
    return this.http.get(this.URL + "/transfer-request", {
      params: {
        warehouse: warehouseId,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getTransferDetailsByTransferId(transferId: number) {
    return this.http.get(this.URL + `/transfer-request-detail/${transferId}`)
  }

  closeTransferDetails(request: CloseTransferDetailsRequest) {
    return this.http.post(this.URL + `/close-transfer`, request);
  }

  updateProductCost(productId: number, cost: number) {
    return this.http.post(this.URL + `/update-product-cost/${productId}`, { newCost: cost });
  }

  getProductsWithoutCost() {
    return this.http.get(this.URL + `/productsWithoutCost`);
  }
  
  getLastProduct(productId: number) {
    return this.http.get(this.URL + `/last-products/${productId}`);
  }

  getProductPricesList() {
    return this.http.get(this.URL + `/product/price/lists`);
  }

  getProductPrices(listId: number) {
    return this.http.get(this.URL + `/product/price/lists/detail/${listId}`);
  }

  getAllWarehouseAndAllProductExistences(type: number) {
    return this.http.get(this.URL + `/warehouses/products/type/${type}`);
  }

  getWarehouseAndProductExistences(warehouseId: number, productId: number) {
    return this.http.get(this.URL + `/warehouses/${warehouseId}/products/${productId}`);
  }

  postProductPrices(data: producPriceRequest) {
    return this.http.post(this.URL + `/product/price/`, data);
  }

  postProductPricesList(data: any) {
    return this.http.post(this.URL + `/product/price/lists`, data);
  }

  putProductPrices(data: producPriceRequest) {
    return this.http.put(this.URL + `/product/price`, data);
  }

  putProductPricesList(listId: number, data: any) {
    return this.http.put(this.URL + `/product/price/lists/${listId}`, data);
  }

  deleteProductPrices(productId: number, listId: number) {
    return this.http.delete(this.URL + `/product/price/${productId}/${listId}`);
  }

  deleteProductPricesList(listId: number) {
    return this.http.delete(this.URL + `/product/price/lists/${listId}`);
  }

  getTransfersSummaryByCompany(warehouseId: number, startDate: number, endDate: number) {
    return this.http.get(this.URL + "/transfer-request-summary", {
      params: {
        warehouse: warehouseId,
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getLasCostProduct(productId: number) {
    return this.http.get(this.URL + `/last-costs/products/${productId}`);
  }

  getTransfersSummaryProductsByCompany(
      warehouseId: number,
      type: number,
      startDate: number,
      endDate: number
  ) {
      return this.http.get(this.URL + `/transfer-request-summary-products`,
        {
          params: {
                  warehouse: warehouseId.toString(),
                  type: type.toString(),
                  startDate: startDate.toString(),
                  endDate: endDate.toString()
              }
        }
      );
  }
}